import axios, {Axios} from 'axios';
import {useAppSelector} from '@hooks/app';
import {useMemo} from 'react';
import {devBaseUrl, prodBaseUrl} from '../api';

//Todo сделать глобальное состояние доступности бека. Если во время выщова аксиос произошел таймаут или недоступен, флаг доступности бека переключается в false. В корневом лейауте
//вместо роутинга рендерим экран заглушку с сообщением что проводятся Тех работы. Если не получаем каталог, сейчас ошибка что не можем получить данные, вместо нее будем рендерить крутящийся лого.
export const useAuthAxios = (): Axios => {
  const {token, token_type} = useAppSelector(state => state.app.token || {token: '', token_type: ''});

  return useMemo(() => axios
    .create({
      baseURL: process.env.NODE_ENV === 'development' ? devBaseUrl : prodBaseUrl,
      headers: {
        Accept: 'application/json',
        ...(token ? {Authorization: `${token_type} ${token}`} : {}),
      },
    }), [token, token_type]);
};